/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsInviteTokenMutationResponse,
  PostTeamsInviteTokenPathParams,
  PostTeamsInviteToken400,
  PostTeamsInviteToken401,
  PostTeamsInviteToken404,
  PostTeamsInviteToken500,
} from "../types/PostTeamsInviteToken.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsInviteTokenMutationKey = () =>
  [{ url: "/teams/invite/:token" }] as const;

export type PostTeamsInviteTokenMutationKey = ReturnType<
  typeof postTeamsInviteTokenMutationKey
>;

/**
 * {@link /teams/invite/:token}
 */
export async function postTeamsInviteToken(
  token: PostTeamsInviteTokenPathParams["token"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTeamsInviteTokenMutationResponse,
    ResponseErrorConfig<
      | PostTeamsInviteToken400
      | PostTeamsInviteToken401
      | PostTeamsInviteToken404
      | PostTeamsInviteToken500
    >,
    unknown
  >({ method: "POST", url: `/teams/invite/${token}`, ...requestConfig });
  return res;
}

export function postTeamsInviteTokenMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = postTeamsInviteTokenMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsInviteTokenMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInviteToken400
      | PostTeamsInviteToken401
      | PostTeamsInviteToken404
      | PostTeamsInviteToken500
    >,
    { token: PostTeamsInviteTokenPathParams["token"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ token }) => {
      return postTeamsInviteToken(token, config);
    },
  });
}

/**
 * {@link /teams/invite/:token}
 */
export function usePostTeamsInviteToken<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsInviteTokenMutationResponse>,
      ResponseErrorConfig<
        | PostTeamsInviteToken400
        | PostTeamsInviteToken401
        | PostTeamsInviteToken404
        | PostTeamsInviteToken500
      >,
      { token: PostTeamsInviteTokenPathParams["token"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTeamsInviteTokenMutationKey();

  const baseOptions = postTeamsInviteTokenMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsInviteTokenMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInviteToken400
      | PostTeamsInviteToken401
      | PostTeamsInviteToken404
      | PostTeamsInviteToken500
    >,
    { token: PostTeamsInviteTokenPathParams["token"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsInviteTokenMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInviteToken400
      | PostTeamsInviteToken401
      | PostTeamsInviteToken404
      | PostTeamsInviteToken500
    >,
    { token: PostTeamsInviteTokenPathParams["token"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsInviteTokenMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInviteToken400
      | PostTeamsInviteToken401
      | PostTeamsInviteToken404
      | PostTeamsInviteToken500
    >,
    { token: PostTeamsInviteTokenPathParams["token"] },
    TContext
  >;
}
